<div #toastContainer class="toast-container position-fixed bottom-0 start-50 translate-middle-x p-3" data-bs-theme="light">
  @for (toast of toasts$ | async; track toast.id) {
    <nexus-toast [toast]="toast" (hidden)="remove(toast.id)"></nexus-toast>
  }
</div>
